function init_girls(from_php){
    var main=$(".place.girls"),
    giftsBook=main.find(".book[g_id='1']"),
    giftBook=main.find(".book[g_id='2']"),
    datesBook=main.find(".book[g_id='3']"),
    dateBook=main.find(".book[g_id='4']"),
    albumBook=main.find(".book.bookFilmStory"),
    collectBook=main.find(".book.bookFilmCollect"),
    giftInput=main.find("#giftCountInput"),
    dateInput=main.find("#dateCountInput"),
    needObj=main.find(".cellBig.girlBar .contentNeed"),
    quickHappyObj=main.find("#girlTrigger,.girlTriggerHappyJS"),
    cur_gift_id=1,cur_date_id=1,
    thermo=main.find(".thermo"),
    animCanvas=main.find("#girlAnimJsCanvas"),
    indexArr={"girl":_moduleTimeHandler.getNewIndex(),"girl_wrong":_moduleTimeHandler.getNewIndex(),
    "eye":_moduleTimeHandler.getNewIndex(),"dialog":_moduleTimeHandler.getNewIndex()};
    var lastDialog={text:"",type:""};
    
    var debugHappy=0;
    var afterCanvasLoad=new afterInit();
    var arrQuest8step=0;
    
    function prepareOneGirlFromList(girlData){
        var timeUse=girlData.happy_end;
        main.find(".cellBig.girlsSet .cell[data-girl_id='"+girlData.girl_id+"'] .imageCustom.myCircleProgress").myCircleProgress(timeUse,10);
    }
    function prepareGirlList(){
        var i;
        for(i in from_php.girls_all){
            prepareOneGirlFromList(from_php.girls_all[i]);
        }
    }
    function showGirlDialog(text,howlong,text_type){
        var box=main.find("#girl_dialog"),
        sexMenu=main.find("#posChooseJS");
        function updateSexMenu(){
            var pos=sexMenu.attr("data-belt_pos");
            if(pos=="bottom"){
                box.removeClass("down");
            }
            else{
                box.addClass("down");
            }
        }
        if(text_type=="sex"){
            updateSexMenu();
            sexMenu.off("updateView").on("updateView",function(){
                updateSexMenu();
            });
        }
        if(!text){
            return false;
        }
        
        function canShowBookDialog(){
            if(main.find(".book:not([g_id='102']):visible").length || main.find(".tutorialBox:visible").length){
                return false;
            }
            return true;
        }
        
        if(!canShowBookDialog()){
            return false;
        }
        
        //main.find("#posChooseJS").hide().attr("data-belt_pos",lastBeltPos)
        if(lastDialog.type=="sex" && text_type=="dialog"){
            return false;
        }
        lastDialog.type=text_type;
        
        
        box.find(".closeCustom").off("click").on("click",function(){
            box.stop(true);
            box.addClass("hide"); 
            _moduleTimeHandler.clear(indexArr.dialog);
        });
        box.stop(true);
        _moduleTimeHandler.clear(indexArr.dialog);
        if(box.is(":visible")){
            var fadeOutTime=600;
            if(text==lastDialog.text){
                box.css({opacity:1});
                _moduleTimeHandler.setOne(indexArr.dialog,function(){
                    box.animate({opacity:0},900);
                    _moduleTimeHandler.setOne(indexArr.dialog,function(){
                        box.addClass("hide");
                    },900);
                    
                },Math.ceil(text.length*40)+2000);
            }
            else{
                box.animate({opacity:0},fadeOutTime);
                _moduleTimeHandler.setOne(indexArr.dialog,function(){
                    box.addClass("hide");
                    showGirlDialog(text,howlong,text_type);
                },fadeOutTime);
            }
            
            lastDialog.text=text;
            return false;
        }
        lastDialog.text=text;
//        howlong=1000;
        _moduleTimeHandler.setOne(indexArr.dialog,function(){
            box.css("opacity",0).removeClass("hide").find(">.content span").html(text).closest(".content").textfill({maxFontPixels:24});
            if(!canShowBookDialog()){
                return false;
            }
            box.animate({opacity:1},600);
            _moduleTimeHandler.setOne(indexArr.dialog,function(){
                box.show();
                _moduleTimeHandler.setOne(indexArr.dialog,function(){
                    box.animate({opacity:0},900);
                    _moduleTimeHandler.setOne(indexArr.dialog,function(){
                        box.addClass("hide");
                    },900);
                },Math.ceil(text.length*40)+2000);
            },600);
        },howlong);
        
    }
    
    if(from_php.ready){
        
        var girlObj= new timerVirtual(from_php.girl);
        var girlIsOwn=girlObj.getLevel()>=girlObj.getLevelMax();
        if(!girlIsOwn){
            init_girls_game(from_php.girl,intval(from_php.talk_max));
        }
        var arrQuest8step=0;
        
        function arrQuest8(mode){
            main.find(".arrowView.arrQuest8").hide();
            if(getQuestId()!=8 || from_php.girl.girl_id!=1){
                return false;
            }
            var arr=girlObj.user;
            if(arr.howlong_have>0){
                if(arr.howlong_have>=arr.howlong_end){
                    return false;
                }
                if(mode=="book"){
                    return false;
                }
                if(mode=="start"){
                    mode="arr";
                }
            }
            
            
            var conf={
                "start":{obj_str:".place.girls .contentNeed .happyJS",arr:{rotation:90,left:-50,top:-16}},
                "book":{obj_str:".place.girls .book.heartBook .girlTriggerHappyJS .imgBig",arr:{rotation:90,left:-60,top:30}},
                "arr":{obj_str:".place.girls #girlTrigger"}
            };
            
            var obj_wrap=$(conf[mode].obj_str),obj;
            
            if(obj_wrap.find(".arrowView").length==0){
                obj_wrap.append("<div class='arrowView arrQuest8'></div>");
                obj=obj_wrap.find(".arrowView");
                if(mode!="arr"){
                    obj.myUpDown(conf[mode].arr);
                }
            }
            else{
                obj=obj_wrap.find(".arrowView");
                obj.show();
            }
            if(mode=="arr"){
                /*
                 {rotation:90,left:35,top:60}
                 {rotation:270,right:15,top:170}
                
                 */
                var arrAll=[{rotation:90,left:35,top:60},{rotation:270,right:15,top:170},{rotation:270,right:25,top:320}];
                arrQuest8step=(arrQuest8step+1)%arrAll.length;
                obj.myUpDown(arrAll[arrQuest8step]);
            }
            //arrQuest8step
        }
        function initBookStats(){
            var girlSet=main.find(".book.bookStats");
            var html="",html_part,i,pos,pos_number=0;
            var positions=from_php.position_arr;
            for(i in positions){
                pos=copyObj(positions[i]);
                pos.girl_id=from_php.girl.girl_id;
                html_part=
                '<div class="cell" data-pos_id="'+pos.pos_id+'">'+
                    '<div><div class="positionProfile"></div></div>'+
                '</div>';
                html_part=$("<div id='wrapTmp'>"+html_part+"</div>").find(".positionProfile").positionProfile({positionArr:pos,size:"min1"}).closest("#wrapTmp").html();
                html+=html_part;
                pos_number++;
            }
            
//            for(;pos_number<14;pos_number++){
//                 html_part=
//                '<div class="cell">'+
//                    '<div><div class="positionProfile min1"></div></div>'+
//                '</div>';
//                html+=html_part;
//            }
            girlSet.find(".flexList").html(html).blankCell();
            
            main.find(".positionSet").myPageSelector({width:520,height:142});


            //cellGirl
        }
        function prepareGiftBook(){
            giftsBook.show();
            var giftBookIn=giftsBook.find(">.content"),html="<div class='flexList'>",bum,i,gifts=_myGifts.takeAll();
            for(i in gifts){
                bum=gifts[i];
                html+=
                "<div class='cell cellJS' data-gift_id='"+bum.gift_id+"'>"+
                    "<div class='name'>"+bum.name+"</div>"+
                    "<div class='imageCustom' style='background-image:url("+_IMG_SERV+"/gfx/gifts/"+bum.gift_id+".png);'></div>"+
                    "<div class='butCash'>"+
                        "<div class='in'>"+
                            "<div>"+
                                numberFormat(bum.cash,1,1)+
                             "</div>"+
                        "</div>"+
                    "</div>"+
                "</div>";
            }
            html+="</div>";
            giftBookIn.find(".giftList").html(html).myPageSelector({width:600,height:312}).
            find(".flexList").blankCell();
            giftBookIn.find(".cell[data-gift_id]").click(function(){
               var th=$(this);
               _mySound.playSound("button_click");
               showGift(intval(th.attr("data-gift_id")),1,1);
               return false;
            });
            giftsBook.myCenter();
            giftsBook.hide();
        }
        function prepareDateBook(){
            datesBook.show();
            var dateBookIn=datesBook.find(">.content");
            dateBookIn.find(".changeDate").each(function(){
                var th=$(this);
                th.html(numberFormat(th.attr('data-cash'),2));
            });
            dateBookIn.find(".cell[data-date_id]").click(function(){
               var th=$(this);
               showDate(intval(th.attr("data-date_id")),1,1);
               return false;
            });
            datesBook.myCenter();
            datesBook.hide();
        }
        function countPremiumCost(cash,howmany){
            var premium=Math.ceil(cash/from_php.premium_conf['cash']);
            premium=Math.min(from_php.premium_conf["premium_max"],premium);
            premium=Math.max(1,premium);
            return premium;
        }
        function countTimeCost(howlong){
            var premium=Math.ceil(howlong/3600*from_php.premium_conf['hour']);
            premium=Math.max(premium,1);
            return premium;
        }
        function initGirlList(){
            var girlList=main.find(".cellBig.girlsSet .girlList");
            girlList.myPageSelector({width:112,height:565,page:intval(from_php.place_id)});
            prepareGirlList();
            girlList.find('.myLink').on("click",function(){
                if(intval($(this).attr("data-was_show"))==1){
                    _mySound.playSound("girl_smile");
                }
            });
        }
        function showDate(date_id,howmany,from_list){
            dateBook.bookUse("show");
            if(from_list){
                dateBook.off("close.listG").on("close.listG",function(){
                    datesBook.bookUse("show");
                });
            }
            cur_date_id=date_id;
            var date=copyObj(from_php.date_stat[date_id]);
            var cashColl=giftBook.find(".cashHideJS");
            var howlongTime=Math.max(10,date.howlong);
            var cash=date.cash*howmany;
            var premium=date.premium;
            
            dateInput.myFormText("update",howmany);
            dateBook.find('.nameJS').html(date.name);
            dateBook.find(".dateImgJS").css("background-image","url("+_IMG_SERV+"/gfx/place/girls/date/icons/"+date.img_name+".png)");
            dateBook.find('.cashJS').html(numberFormat(cash));
            dateBook.find(".cashJSbut").attr("data-need",cash+"c");
            dateBook.find('.happyJS').html(numberFormat(date.happy*howmany));
            dateBook.find('.premiumJS').html(numberFormat(premium));
            dateBook.find(".premiumJSbut").attr("data-need",premium+"p");
            
            dateBook.find('.timeJS').html(timeFormat(howlongTime));
            dateBook.find("input[name='date_count']").val(howmany);
            dateBook.find("input[name='date_id']").val(date_id);
            if(date.cash==0){
                giftBook.find('.flexCashJS').css("justify-content","space-around");
                cashColl.hide();
            }
            else{
                giftBook.find('.flexCashJS').css("justify-content","space-between");
                cashColl.show();
            }
            $.updateButtons();
        }
        function showGift(gift_id,howmany,from_list){
            giftBook.bookUse("show");
            if(from_list){
                giftBook.off("close.listG").on("close.listG",function(){
                    giftsBook.bookUse("show");
                });
            }
            cur_gift_id=gift_id;
            var gift=_myGifts.takeGift(gift_id);
            var cashColl=giftBook.find(".cashHideJS");
            var freeColl=giftBook.find(".flexFreeJS");
            var howmany_to_buy=howmany,giftOwn=0;
            if(typeof from_php.gift_own[gift_id]!=="undefined"){
                howmany_to_buy=Math.max(0,howmany-from_php.gift_own[gift_id]);
                giftOwn=from_php.gift_own[gift_id];
            }
            if(intval(giftOwn)){
                giftBook.find(".giftOwnJS").show().find(".val").html("x"+giftOwn);
            }
            else{
                giftBook.find(".giftOwnJS").hide();
            }
            var cash=gift.cash*howmany_to_buy;
            var premium=countPremiumCost(cash,howmany_to_buy);
            if(gift.premium){
                premium=gift.premium*howmany_to_buy;
            }
            if(howmany_to_buy==0){
                premium=0;
            }
            giftInput.myFormText("update",howmany);
            giftBook.find('.nameJS').html(gift.name);
            giftBook.find(".giftImgJS").css("background-image","url("+_IMG_SERV+"/gfx/gifts/"+gift_id+".png)");
            giftBook.find('.cashJS').html(numberFormat(cash));
            giftBook.find(".cashJSbut").attr("data-need",cash+"c");
            giftBook.find('.happyJS').html(numberFormat(gift.happy*howmany));
            giftBook.find('.premiumJS').html(numberFormat(premium));
            giftBook.find(".premiumJSbut").attr("data-need",premium+"p");
            giftBook.find("input[name='gift_count']").val(howmany);
            giftBook.find("input[name='gift_id']").val(gift_id);
            if(cash==0){
                giftBook.find('.flexCashJS').css("justify-content","space-around");
                cashColl.hide();
                var text=from_php.langs.free_gift;
                text=connectVars(text,["x"+howmany],"#");
                freeColl.show().find(".valJS").html(text);
            }
            else{
                giftBook.find('.flexCashJS').css("justify-content","space-between");
                cashColl.show();
                freeColl.hide();
            }
            if(premium){
                giftBook.find(".flexCashJS").show();
            }
            else{
                giftBook.find(".flexCashJS").hide();
            }
            giftBook.find(".arrJSselector").off("click.nextGift").on("click.nextGift",function(){
                var cur_gift_id_new=cur_gift_id;
                cur_gift_id_new+=intval($(this).attr("data-val"));
                cur_gift_id_new=Math.max(1,cur_gift_id_new);
                cur_gift_id_new=Math.min(cur_gift_id_new,_myGifts.id_max);
                if(cur_gift_id_new!=cur_gift_id){
                    showGift(cur_gift_id_new,1);
                }
            });
            $.updateButtons();
        }
        function prepareThermo(obj){
            var border=thermo.find(".fill_border");
            border.css('height',"");
            border.css("height",Math.round(border.height()*Math.min(obj.level_max,obj.level+1)/10)+"px");
             
            girlObj= new timerVirtual(obj,"girl");
            girlObj.makeStatus();
            
            var thermoText=thermo.find(".thermoText>.in");
            var happyRow=main.find(".rowHappy"), 
            happyText=happyRow.find("#hhPsP"), happyPr=happyRow.find("#hhPs"),beltFill=happyRow.find(".beltHappy>.fill");
            var arr=girlObj.user;
            if(debugHappy==0 && arr.howlong_have>=arr.howlong_end){
                debugHappy=1;
                if(getQuestId()=="6" && getQuestVars()=="2"){
                    prepareQuest(0,"book");
                }
                prepareNeed();
            }
            function on_step(percent){
                beltFill.width(percent+"%");
                thermoText.html(numberFormat(arr.level*10+percent/10,0,0,1)+"%");
                happyPr.html(numberFormat(percent,0,0,2)+"%");
                happyText.html(numberFormat(percent*arr.howlong_end/100,2,1));
                thermo.find(".fill_border>.fill").height(
                    ((percent/100*arr.howlong_end+arr.howlong_end*arr.level)/(arr.howlong_end*(arr.level+1))*100)+"%"
                );
            }
            if(!arr.is_blocked){
                beltFill.beltTimer(arr.howlong_have,arr.howlong_end,girlObj.takeNewLevelTime(),{
                    on_end:function(){
                        thermoText.html(Math.min(arr.level+1,arr.level_max)*10+"%");
                        happyPr.html("100%");
                        beltFill.width(100+"%");
                        happyText.html(numberFormat(arr.howlong_end,1,1));
                    },
                    on_end_timer:function(){
                        if(!girlIsOwn){
                            prepareNeed();
                        }
                    },
                    on_step:function(percent_belt){
                        on_step(percent_belt);
                    },
                },_moduleTimeHandler);
            }
            else{
                var howlong_have=arr.howlong_have;
                if(howlong_have==1){
                    howlong_have=0;
                }
                var percent=howlong_have/arr.howlong_end*100;
                percent=Math.min(100,percent);
                on_step(percent);
            }
            var i,indexThermoArr={};
            for(i=1;i<=10;i++){
                indexThermoArr[i]=_moduleTimeHandler.getNewIndex();
            }
            
            thermo.find(".photoHint").click(function(){
                var th=$(this),level=intval(th.attr('data-level'));
                albumBook.one("open",function(){
                    var trig=albumBook.find(".partDown .cellWrap .cover[data-level='"+level+"']");
                    if(trig.length){
                        trig.closest(".cell").trigger("click");
                    }
                    else{
                        albumBook.find(".partDown .cellWrap .cover[data-level='0']").eq(0).closest(".cell").trigger("click"); 
                    }
                    
                }).bookUse("show",0,"not_trigger");
                return false;
            }).on("mouseenter",function(){
                var th=$(this),level=intval(th.attr('data-level')),stateAn=th.attr("data-state");
                //(timeHandler,timeHandlerIndex
                if(stateAn=="new" || stateAn=="ready"){
                    th.find(".iconAnim").throwDown(_moduleTimeHandler,indexThermoArr[level],{v_arr:[2.6,1.3]});
                }
                
            });;
            var thermoUp=thermo.find('.thermoUp,.thermo .star'),thermoStar=thermo.find('.star');
            thermo.find('.thermoUp,.star').click(function(e){
                var realTarget=$(e.target)[0];//star
                if(thermoUp[0]===realTarget || thermoStar[0]===realTarget){
                                                           
                    albumBook.one("open",function(){
                        var trig=albumBook.find(".partDown .cellWrap .cover[data-level]").filter(function(){
                            if(intval($(this).attr("data-level"))){
                                return 1;
                            }
                            return 0;
                        }).last();
                        if(trig.length){
                            trig.closest(".cell").trigger("click");
                        }
                    }).bookUse("show",0,"not_trigger");
                    return false;
                }
            });
            
        }
        function initNeed(){
            prepareNeed(1);
            var needObj=main.find(".contentNeed");
            var i,bum,val,type,obj=from_php.need_arr;
            function addAnim(type_id){
                var obj=needObj.find(".cell[data-type='skill'][data-type_id='"+type_id+"'] .blinkJS");
                var step=0;
                _moduleTimeHandler.add(function(){
                    step=(step+1)%2;
                    if(step){
                        obj.show();
                    }
                    else{
                        obj.hide();
                    }
                },1000);
            }
            for(i in obj){
                bum=obj[i];
                val=bum.val;
                type=bum.type;
                if(type=="skill"){
                    val=_SkillSet.objSet[bum.type_id].getLevel();
                    if(val<bum.val_max && _SkillSet.objSet[bum.type_id].isWorking()){
                        addAnim(bum.type_id);
                    }
                }
                
            }
        }
        function handleNotReady(obj){
            obj.off("triggerCam").on("triggerCam",function(){
                var th=$(this);
                var timeIndex=th.takeObjTimeHanderIndex(_moduleTimeHandler);
                if(!th.is("[data-ready='1']") && !_moduleTimeHandler.isIndexSet(timeIndex)){
                    var step=0,step_max=10,dir=1;
                    th.append("<div class='needWrongCam'><div>"+from_php.langs.need_before_cam+"</div></div>");
                    var text=th.find(".needWrongCam"),showHide=th.find(".imageCustom,.textObj");
                    showHide.hide();
                    _moduleTimeHandler.set(timeIndex,function(){
                        step+=dir;
                        if(step>=step_max){
                            dir=-1;
                        }
                        if(step<=0){
                            _moduleTimeHandler.clear(timeIndex);
                        }
                        else if(dir==-1){
                            text.css("opacity",step/step_max)
                        }
                    },50,function(){
                        text.remove();
                        showHide.show();
                    });
                }
                
            });
        }
        function handleReady(obj){
            obj.removeClass("item,myLink").removeAttr("data-date_id data-gift_id").off("click").on("click",function(){
                var th=$(this);
                var timeIndex=th.takeObjTimeHanderIndex(_moduleTimeHandler);
                if(!_moduleTimeHandler.isIndexSet(timeIndex)){
                    var step=0,step_max=10,dir=1;
                    th.append("<div class='needDone'><div>"+from_php.langs.need_done+"</div></div>");
                    var text=th.find(".needDone"),showHide=th.find(".imageCustom,.textObj");
                    showHide.hide();
                    _moduleTimeHandler.set(timeIndex,function(){
                        step+=dir;
                        if(step>=step_max){
                            dir=-1;
                        }
                        if(step<=0){
                            _moduleTimeHandler.clear(timeIndex);
                        }
                        else if(dir==-1){
                            text.css("opacity",step/step_max)
                        }
                    },50,function(){
                        text.remove();
                        showHide.show();
                    });
                }
                
            });
        }
        function prepareNeed(was_init){
            var obj=from_php.need_arr;
            var needObj=main.find(".contentNeed");
            needObj.find(".cell").attr("data-ready",0);
                    
                    
            girlObj.makeStatus();
            var arr=girlObj.user,is_ready=1;
            var happyIsReady=0;
            needObj.find("#happyMaxNeedJS").html(numberFormat(arr.howlong_end,2,1));
            if(arr.howlong_end>arr.howlong_have){
                is_ready=0;
                handleNotReady(needObj.find(".cell[data-type='happy']"));
            }
            else{
                handleReady(needObj.find(".cell[data-type='happy']").attr("data-ready",1));
                happyIsReady=1;
            }
            var i,bum,val,type,type_id,dont_have=[];
            for(i in obj){
                bum=obj[i];
                val=bum.val;
                type=bum.type;
                type_id=0;
                if(type=="skill"){
                    val=_SkillSet.objSet[bum.type_id].getLevel();
                    val=Math.min(val,bum.val_max);
                    type_id=bum.type_id;
                    needObj.find(".cell[data-type='"+type+"'][data-type_id='"+bum.type_id+"'] .fillJS").html(val+" / "+bum.val_max);
                }
                if(type=="cash"){
                    val=_myProfile.takeData("cash");
                    var cash_max=bum.val_max,cashHtmlObj=main.find("#girlNeedCashJS");
                    if(val<bum.val_max){
                        
                        _moduleEvents.off("cash.prepareNeed").on("cash.prepareNeed",function(cash){
                            if(cash>=bum.val_max){
                                prepareNeed();
                            }
                            if(cash_max<1000){
                                cashHtmlObj.html(Math.min(cash,cash_max)+" / "+cash_max);
                            }
                        });
                    }
                }
                if(type=="cash_id"){
                    val=_cashObjSet.objSet[bum.type_id].isOwn();
                }
                if(val>=bum.val_max){
                    handleReady(needObj.find(".cell[data-type='"+type+"'][data-type_id='"+bum.type_id+"']").attr("data-ready",1));
                }
                else{
                    dont_have.push({type:type,val_max:bum.val_max,val:val,type_id:type_id});
                    is_ready=0;
                    handleNotReady(needObj.find(".cell[data-type='"+type+"'][data-type_id='"+bum.type_id+"']"));
                }
            }
            if(is_ready){
                preapareReadyLevelWindow(was_init);
            }
            handleDontHave(dont_have,happyIsReady);
            return is_ready;
        }
        function handleDontHave(dont_have,happyIsReady){
            
            var needObj=main.find(".contentNeed");
            needObj.find(".handleNeedObj").remove();
            var q_id=getQuestId();
            if(q_id==8 && dont_have.length==1){
                prepareQuest(0,0);
            }
            if((q_id==6 || q_id==8) && happyIsReady){
                var obj,i,only_skill=1;
                for(i in dont_have){
                    if(dont_have[i].type!="skill"){
                        only_skill=0;
                    }
                }
                if(only_skill && dont_have.length){
                    obj=false;
                    for(i in dont_have){
                        if(_SkillSet.objSet[dont_have[i].type_id].isWorking()){
                            obj=dont_have[i];
                            break;
                        }
                    }
                    if(obj!==false){
                        var timeId="skillBox"+obj.type_id+"_"+obj.val_max;
                        var html=
                        "<div class='boxTip handleNeedObj'>"+
                            "<div class='content'>"+
                                "<div class='line'>"+
                                    connectVars(from_php.langs.need_skill_box_cap,["<span class='boxtimer' id='"+timeId+"'></span>"],"#")+
                                "</div>"+
                                "<div class='line'>"+from_php.langs.need_skill_box_desc+"</div>"+
                            "</div>"+
                        "</div>";
                        needObj.find(".cell[data-type='"+obj.type+"'][data-type_id='"+obj.type_id+"']").append(html);
                        _timerManager.addTimer(
                            ".place.girls #"+timeId,
                            _SkillSet.objSet[obj.type_id].takeTimeToLevel(obj.val_max),
                            1
                        );
                    }
                }
            }
            
        }
        function onNewLevel(){
            afterCanvasLoad.addFun(function(){
                main.find(".tutorialBox").hide();
                init_girls_clip_anim(main,from_php,animCanvas,"before");
            });
            //girlNewLevel
        }
        $.ttt=function(){
            onNewLevel();
        };
        function preapareReadyLevelWindow(was_init){
            if(typeof from_php.was_reload_js!="undefined" || girlObj.getLevel()>=girlObj.getLevelMax()){
                return false;
            }
            var q_id=getQuestId();
            if(q_id==3){
                $.goToLocation("girls");
            }
            if(q_id==6){
                prepareQuest(0,"book");
            }
            if(from_php.film.collected){
                //reload
                if(!was_init || !from_php.was_reload){
                    var book=main.find(".book.bookFilmStory");
                    if(book.is(":visible")){
                        main.find("#showNextGirlLevelJS").hide();
                        book.one("close",function(){
                            onNewLevel();
                            
                        });
                    }
                    else{
                        onNewLevel();
                    }
                }
            }
            else if(!main.is(".gameIsReadyJS")){
                if(from_php.film.time_start==1 && from_php.film.time_end==1){
                    main.find(".book[g_id='102']").bookUse("show");
                    main.find("#recButtJSRow").removeClass("hide");
                    var butRec=main.find("#recButtJS");
                    if(butRec.find(".arrowView").length==0){
                        butRec.append("<div class='arrowView'></div>");
                        butRec.find(".arrowView").myUpDown({'rotation':90,left:-60,top:-10});
                    }
                    main.find("#recButtJSRowUn").addClass("hide");
                }
                else if(from_php.film.time_end==1 && from_php.film.time_start>2 && from_php.film.time_start<getCurrentTime()){
                    //collect book
                }
                else{    
                    main.find(".book[g_id='6']").bookUse("show");
                }
            }
        }
        function girlWrong(){
            if(_moduleTimeHandler.isIndexSet(indexArr.girl_wrong)){
                return false;
            }
             showGirlDialog(from_php.langs.dialog_happy_full,20,"wrong");
            _mySound.playSound("girl_happy_max");
            var dir=1,step=0,step_max=4,girlJsObj=main.find("#girl"),girlJsObjWrong=main.find("#girl .wrongGirl"),
                girlJsExtend=main.find("#girl_extend");
            girlJsExtend.hide();
            _moduleTimeHandler.set(indexArr.girl_wrong,function(){
                step+=dir;
                if(step>=step_max){
                    dir=-1;
                }
                girlJsObjWrong.css({"opacity":((step/step_max)*0.5+0.5),"background-size":(100-(step/step_max)*3)+"%"});
                girlJsObj.css({"background-size":(100-(step/step_max)*3)+"%"});
                if(step<=0){
                    _moduleTimeHandler.clear(indexArr.girl_wrong);
                }
            },40,function(){
                girlJsExtend.show();
                girlJsObjWrong.css("opacity",0);
            });
        }
        function prepareQuickHappy(){
            //quickHappyObj
            var happy_count=0,is_running=0;
            var send_happy_end=0;
            function addGirlHappy(no_sound){
                var add=Math.floor(from_php.girl.quick_happy);
                from_php.girl.howlong_have+=add;
                prepareThermo(from_php.girl);
                animCanvas.startGirlAnim("addAnim",$.takeGirlPositionConf(from_php.girl.girl_id,from_php.girl.level).center);
                if(!no_sound){
                    _mySound.playSound("girl_heart_appear");
                }
                
                animGirl();
                
                girlObj= new timerVirtual(from_php.girl,"girl");
                girlObj.makeStatus();
                var arr=girlObj.user;
                
                if(arr.howlong_have>=arr.howlong_end && arr.howlong_have-add<arr.howlong_end){
                    prepareNeed();
//                    if(getQuestId()==3){
//                        $.goToLocation("girls");
//                    }
                }
            }
            function sendRequest(){
                $.mypost("/ajax/girlsquick",{girl_id:from_php.girl.girl_id,happyQuick:happy_count,send_happy_end:send_happy_end},function(res){
                        var data=handleAjaxRes(res);
                        if(typeof data=="object"){
                            send_happy_end=0;
                            if(data.happy_end!=from_php.girl.happy_end){
                                prepareOneGirlFromList(data);
                            }
                            from_php.girl=copyObj(data);
                            prepareThermo(from_php.girl);
                            girlObj= new timerVirtual(from_php.girl,"girl");
//                            $.qLog(" ajaxRes ");
                            _semaphoreXHR.sendXhr();
                        }
                },"json");
            }
            var indexRuning=_moduleTimeHandler.getNewIndex(),indexStop=_moduleTimeHandler.getNewIndex();
            main.on("click touchstart touchmove touchend",function(e){
                var target_id=$(e.target).attr("id");
                if(target_id=="girlGameJsCanvas"){
                    return false;
                }
            });
            
            quickHappyObj.on("touchstart",function(e){
                quickHappyObj.trigger("triggerHH");
                var bookQ=$(e.target).closest(".book");
                if(bookQ.length){
                    bookQ.bookUse("hide");
                }
                return false;
            });
            quickHappyObj.on("click triggerHH",function(){
                girlObj.makeStatus();
                var arr=girlObj.user;
                if(arr.howlong_have<arr.howlong_end){
                
                
                    if(from_php.girl.happy_end<=getCurrentTime()){
//                        $.qLog(" CH ");
                        _mySound.playSound("girl_moan");
                        from_php.girl.happy_end=getCurrentTime()+10;
                        prepareOneGirlFromList(from_php.girl);
                        send_happy_end=1;
                        happy_count+=1;
                        if(_moduleTimeHandler.isIndexSet(indexRuning)){
//                            $.qLog(" timerClearHappy ");
                            _moduleTimeHandler.clear(indexRuning);
                        }
                        else{
//                            $.qLog(" requestHappy");
                            sendRequest();
                        }
                        addGirlHappy(1);
                    }
                    else if(!is_running){
//                        $.qLog(" C ");
                        is_running=1;
                        addGirlHappy();
                        happy_count+=1;
                        _semaphoreXHR.setBeforeSendXhr(function(url){
                            if(url=="/girls/"+from_php.girl_id+"/" || url=="/girls/"){
//                                $.qLog(" timerClearNEWmodule")
                                _moduleTimeHandler.clear(indexRuning); 
                            }
                            else{
//                                $.qLog(" sendXhrDiff")
                                _semaphoreXHR.sendXhr();
    //                            $.qLog("XHRforward ");
                            }
                            
                        });
                        _moduleTimeHandler.setOne(indexRuning,function(){

                        },2000,function(){
//                            $.qLog(" timerClear ");
                            sendRequest();
                            happy_count=0;
                        });
                        if(happy_count>=12){
//                            $.qLog(" timerClearCount ");
                           _moduleTimeHandler.clear(indexRuning); 
                        }
                        _moduleTimeHandler.setOne(indexStop,function(){
                            is_running=0;
                        },250);
                    }
                }
                else{
                    girlWrong();
                }
                arrQuest8("arr");
            });
        }
        function prepareGirlCss(){
            
            var girl_level_view=from_php.girl.level;
            var girl_ext=main.find("#girl_extend");
            var girl_name=$.takeGirlImage(from_php.girl_id)
            var eye=girl_ext.find(".eye").hide();
            var girl_conf=$.takeGirlPositionConf(from_php.girl.girl_id,girl_level_view);
            if(girl_level_view==10){
                girl_level_view="10_1";
                var eye_conf=$.takeGirlConf(from_php.girl.girl_id,"eye10");
                if(typeof eye_conf=="object"){
                    eye_conf=10;
                }
                
                eye.attr("data-girl_level",eye_conf);
            }
            else{
                if(typeof girl_conf.anim_add !="undefined"){
                    var animObj=girl_ext.find(".anim_add"),animConf=girl_conf.anim_add;
                    animObj.css({
                        width:animConf.width+"px",
                        height:animConf.height+"px",
                        left:animConf.left+"px",
                        top:animConf.top+"px",
                        "background-image":"url("+_IMG_SERV+"/gfx/girls/"+girl_name+"/position/"+girl_level_view+"_anim.png)"
                    });
                    animObj.qAnim({
                        clips:animConf.clips,
                        width:animConf.width,
                        loop:1,
                        interval:100,
                        wait_arr:[50,100],
                        animArr:copyArray(animConf.animArr)
                    });
                }
            }
            eye=eye.hide().eq(0);
            
            if(from_php.girl.level==10){
                var qconf=$.takeGirlPositionConf(from_php.girl.girl_id,"10_1");
                if(typeof qconf.width!="undefined"){
                    girl_conf=qconf;
                }
            }
                
            
            main.find("#girlTrigger").css({left:girl_conf.left+"px",top:girl_conf.top+"px",width:girl_conf.width+"px",height:girl_conf.height+"px"});
            
            
            
            var step_max=20,step=mt_rand(5,step_max);
            _moduleTimeHandler.set(indexArr.eye,function(){
                if(step>0 && step<4){
                    if(!_moduleTimeHandler.isIndexSet(indexArr.girl)){
                        var attrType=step;
                        if(step==3){
                            attrType=1;
                        }
                        eye.attr("data-type",attrType).show();
                    }
                    else{
                       eye.hide(); 
                    }
                }
                if(step==4){
                    eye.hide();
                }
                step++;
                if(step>step_max){
                    step=0,
                    step_max=mt_rand(20,100);
                }
            },100,function(){
                eye.hide(); 
            });
            function anim10(){
                //pos_last
                var img_last=$.takeGirlConf(from_php.girl.girl_id,"pos_last"),i,arr_load=[];
                for(i=1;i<=img_last;i++){
                    arr_load.push(""+_IMG_SERV+"/gfx/girls/"+$.takeGirlImage(from_php.girl.girl_id)+"/position/ready/10_"+i+".png"+$.takeGirlVersion(from_php.girl.girl_id));
                }
                var anim10conf=$.takeGirlConf(from_php.girl.girl_id,"anim10");
                var interval=100;
                var timeIndex=[_moduleTimeHandler.getNewIndex(),_moduleTimeHandler.getNewIndex()];
                var step=-10,step_max=mt_rand(30,90),wait=0,wait_max=0,loop=0;
                if(typeof anim10conf.loop!="undefined" && anim10conf.loop){
                    loop=1;
                    step_max=mt_rand(10,25);
//                    step_max=img_last*2-1;
//                    step=1;
//                    interval*=3;
                }
                if(typeof anim10conf.waitOnLast!="undefined" && anim10conf.waitOnLast){
                    wait_max=Math.round(anim10conf.waitOnLast/interval)+1;
                    wait=wait_max;
                }
                
                function make10Anim(){
                    _moduleTimeHandler.set(timeIndex[0],function(){
                        if(wait<wait_max){
                            wait++;
                            return false;
                        }
                        step++;
                        if(step>0 && step<img_last*2){
                            var img=img_last-Math.abs(img_last-step);
                            main.attr("data-girl_level","10_"+img);
                        }
                        if(step==img_last && wait_max){
                            wait=0;
                        }
                        if(step==step_max){
                            if(loop){
                                step=0;
                                step_max=mt_rand(10,25);
                            }
                            else{
                                step=0;
                                step_max=mt_rand(30,90);
                            }

                        }
                       return true;
                    },interval);
                }
                $("<div></div>").one("myload",function(){
                    make10Anim();
                }).myLoad(arr_load);
                
            }
            if(from_php.girl.level==10){
                anim10();
            }
            
        }
        function insertGirlToCover(bookDuring){
            var girlObj=main.find(">#girl:not(.tmp)");
            var cssObj={width:girlObj.width(),height:girlObj.height(),top:intval(girlObj.css("top")),left:intval(girlObj.css("left"))};
            var filmObj=bookDuring.find(".filmDuringFJS");
            var filmCss=[filmObj.width(),filmObj.height()];
            var mainSize=[1280,780];
            var mainHeightShow=Math.round(filmCss[1]/filmCss[0]*mainSize[0]);
            var top=0,remain=0;
            if(cssObj.height>=mainHeightShow){
                top=cssObj.top;
            }
            else{
                remain=(mainHeightShow-cssObj.height)/2;
                top=cssObj.top-remain;
            }
            var scale=filmCss[0]/mainSize[0];
            filmObj.css("background-position","0px -"+Math.round(top*scale)+"px").append("<div class='girl' style='width:"+Math.round(cssObj.width*scale)+"px;"+
            "height:"+Math.round(cssObj.height*scale)+"px;left:"+Math.round(cssObj.left*scale)+"px;top:"+Math.round(remain*scale)+"px;"+
            "background-image:"+girlObj.css("background-image")+"'></div>");
//            debugArr(cssObj);
        }
        function prepareCollect(){
            var filmData=from_php.film;
            var cash_id=filmData.cash_id_max,progress_add=filmData.add_max;
            var cashArrCur=_cashObjSet.objSet[cash_id].takeCash(1);
            var cashObjNext=copyObj(_cashObjSet.objSet[cash_id]);
            cashObjNext.addOneProgress(progress_add,getCurrentTime());
            var cashObjPremium=copyObj(_cashObjSet.objSet[cash_id]);
            cashObjPremium.addOneProgress(progress_add*2,getCurrentTime());
            var cashArrNext=cashObjNext.takeCash(1);
            var cashArrPremium=cashObjPremium.takeCash(1);
            
            //film_have":229,"film_end":290,
            
            collectBook.find(".buildLevelJS").html(cashArrCur.level);
            collectBook.find(".earnBuildCurJS").html(cashFormat(cashArrCur.cash_on_hour_with_bonus)+"/h");
            collectBook.find(".borderFill .fill").width(Math.min(100,cashArrCur.film_have/cashArrCur.film_end*100)+"%").
            filter(".premium").width(Math.min(100,(cashArrCur.film_have+progress_add*2)/cashArrCur.film_end*100)+"%").end().
            filter(".add").width(Math.min(100,(cashArrCur.film_have+progress_add)/cashArrCur.film_end*100)+"%");
            
            collectBook.find(".borderFill .textWrap .in").filter(".addJS").
            html(numberFormat(cashArrCur.film_have+progress_add)+"/"+numberFormat(cashArrCur.film_end)).end().
            filter(".premiumJS").html(numberFormat(cashArrCur.film_have+progress_add*2)+"/"+numberFormat(cashArrCur.film_end));
            
            if(cashArrNext.level>cashArrCur.level){
                collectBook.find(".buildLevelJSadd").html("+"+(cashArrNext.level-cashArrCur.level));
                collectBook.find(".earnBuildAddJS").html(" + "+cashFormat(cashArrNext.cash_on_hour_with_bonus-cashArrCur.cash_on_hour_with_bonus)+"/h");
            }
            if(cashArrPremium.level>cashArrCur.level){
                collectBook.find(".buildLevelJSpremium").html("+"+(cashArrPremium.level-cashArrCur.level));
                collectBook.find(".earnBuildPremiumJS").html(" + "+cashFormat(cashArrPremium.cash_on_hour_with_bonus-cashArrCur.cash_on_hour_with_bonus)+"/h");
            }
            
        }
        function prepareFilm(){
            var objFilm=main.find("#filmCellJS");
            var film=from_php.film;
            if(film.time_start>1 && film.time_end>1){
                main.find(".camShow[data-type_id='1']").show();
                main.find("#recButtJSRowUn").addClass("hide");
                var bookDuring=main.find(".book.filmDuring"),timerDuring=bookDuring.find(".borderFill .fill");
                var recObj=main.find(".cellFilm .borderFill .rec"),step=0,allCams=main.find(".camShow[data-type_id]").add(bookDuring.find(".bigCam"));
                _moduleTimeHandler.add(function(){
                    step=(step+1)%2
                    recObj.attr("data-step",step);
                    if(step==0){
                        allCams.addClass("blink");
                    }
                    else{
                        allCams.removeClass("blink");
                    }
                },1500);
                var leftBack=0,objBack=bookDuring.find(".filmBorderBig .belt");
                _moduleTimeHandler.add(function(){
                    leftBack++;
                    leftBack=leftBack%24;
                    objBack.css("background-position",leftBack+"px 0px");
                },40);
                
                
                objFilm.find(".hideOnActive").hide();
                var belt=objFilm.find(".borderFill").show().find(".borderFillWrap>.fill");
                var curTime=getCurrentTime(),premiumLast=0;
                film.time_end=intval(film.time_end);
                belt.beltTimer(curTime-film.time_start,film.time_end-film.time_start,film.time_end,{
                    on_end:function(){
                        if(!main.is(".gameIsReadyJS")){
                            $.goToLocation("girls/"+from_php.girl_id+"/",{post_state:"film_ended"});
                        }
                    },
                    on_step:function(percent){
                        var howlong=Math.max(1,film.time_end-getCurrentTime());
                        var on_hour=3+from_php.girl_id/12*7;
                        on_hour=Math.min(on_hour,10);
                        var premiumCost=Math.ceil(howlong/3600*on_hour);
                        premiumCost=Math.min(premiumCost,15);
                        if(premiumCost!=premiumLast){
                            premiumLast=premiumCost;
                            bookDuring.find("#premiumSpeedUPJS").attr("data-need",premiumCost+"p").updateButton().find(".in").html(premiumCost);
                        }
                        timerDuring.width(percent+"%");
                    }
                },_moduleTimeHandler);
                _timerManager.addTimer(".place.girls .timerFilmShowJS",film.time_end,1);
                
                
                var cashArr=_cashObjSet.objSet[film.cash_id_max].takeCash(1);
                bookDuring.find(".cashProfile").cashProfile({cashArr:cashArr,size:"medium"});
                bookDuring.find('#filmCountJS').html(numberFormat(film.add_max));
                bookDuring.find(".buildImgJS").css('background-image',"url("+_IMG_SERV+"/gfx/place/cash/build/"+film.cash_id_max+".png)");
                bookDuring.find(".buildLevelJS").html(cashArr.level);
                insertGirlToCover(bookDuring);
                bookDuring.off("open.durIndex").on("open.durIndex",function(){
                   main.find(".cellBig.girlsSet").addClass("over");
                });
                bookDuring.off("close.durIndex").on("close.durIndex",function(){
                   main.find(".cellBig.girlsSet").removeClass("over");
                });
            }
        }
        function prepareCanvas(){
            animCanvas.attr({width:main.width(),height:main.height()});
            animCanvas.on("endElipse",function(){
                
                _mySound.playSound("heart_in");
            }).one("was_loaded",function(){
                afterCanvasLoad.load();
                if(typeof from_php.happy_show!="undefined" && from_php.happy_show>0){
                    
                    var arr=girlObj.takeTimerObj();
                    var i,i_max=Math.ceil(intval(from_php.happy_show)/arr.howlong_end*20);
                    i_max=Math.min(10,i_max);
                    animCanvas.startGirlAnim("addAnim",$.takeGirlPositionConf(from_php.girl.girl_id,from_php.girl.level).center);
                    for(i=1;i<i_max;i++){
                        _moduleTimeHandler.addOne(function(){
                            animCanvas.startGirlAnim("addAnim",$.takeGirlPositionConf(from_php.girl.girl_id,from_php.girl.level).center);
                        },i*300);
                    }

                }
                
                
                
            }).startGirlAnim({},_moduleTimeHandler);
            
        }
        function prepareAlbumBook(){
            function takePlaceName(girl_name,level){
                var place_img=from_php.place_id,
                place_girl_own=["cherry","lola","sanshi","ice","geeky","maggie","winona","anya","anya0","linn"];

                if(in_array(girl_name,place_girl_own)){
                    place_img=girl_name;
                }
                if(in_array(girl_name+level,place_girl_own)){
                    place_img=girl_name+level;
                }
                return place_img;
            }
            albumBook.on("open",function(e,trigger_vars){
                if(!albumBook.is(".is_ready")){
                    var girl_name=$.takeGirlImage(from_php.girl_id),level_max=0;
                    albumBook.addClass("is_ready").find(".cover[data-level]").each(function(){
                        var th=$(this),level=th.attr("data-level");
                        if(level>0){
                            level_max=Math.max(level_max,level);
                            var tmp=$.takeGirlPositionConf(from_php.girl_id,level-1);
                            th.myBackgroundImage({
                                showFullImageIndex:1
                            },[
                                {path:""+_IMG_SERV+"/gfx/place/girls/places/"+takePlaceName(girl_name,level-1)+".jpg",left:0,top:0},
                                {path:""+_IMG_SERV+"/gfx/girls/"+girl_name+"/position/ready/"+(level-1)+".png"+$.takeGirlVersion(from_php.girl_id),left:tmp.left,top:tmp.top}

                            ]);
                        }
                    });
                    
                    
                    var qobj=albumBook.find(".partDown .cell").off("click").click(function(){
                        albumBook.find(".cell").removeClass("active");
                        
                        var th=$(this).find(".cover"),level=intval(th.attr("data-level"));
//                        albumBook.find(".photoBigJS .cell.big").show();
                        
                        
                        th.closest(".cell").addClass("active");
                        if(level>0){
                            var tmp=$.takeGirlPositionConf(from_php.girl_id,level-1);
                            albumBook.find(".photoBigJS").myBackgroundImage({
                                showFullImageIndex:1
                            },[
                                {path:""+_IMG_SERV+"/gfx/place/girls/places/"+takePlaceName(girl_name,level-1)+".jpg",left:0,top:0},
                                {path:""+_IMG_SERV+"/gfx/girls/"+girl_name+"/position/ready/"+(level-1)+".png"+$.takeGirlVersion(from_php.girl_id),left:tmp.left,top:tmp.top}

                            ]).addClass("active").attr("cur_level",level);
                        }
                        else{
                            albumBook.find(".photoBigJS").css("background-image","none").removeClass("active").attr("cur_level",0);
                        }
                        
                    }).eq(0);
                    if(typeof trigger_vars=="undefined" || trigger_vars!="not_trigger"){
                        qobj.trigger("click");
                    }
                    
                    albumBook.find(".inputArrowLeft,.inputArrowRight").click(function(){
                        _mySound.playSound("page_selector");
                        var backPhoto=albumBook.find(".photoBigJS"),cur_level=intval(backPhoto.attr("cur_level"));
                        if($(this).is(".inputArrowLeft")){
                            cur_level--;
                        }
                        else{
                            cur_level++;
                        }
                        if(level_max==11){
                            if(cur_level==0){
                                cur_level=11;
                            }
                            if(cur_level==12){
                                cur_level=1;
                            }
                        }
                        else{
                            if(cur_level==level_max+1){
                                cur_level=0;
                            }
                            if(cur_level==-1){
                                cur_level=level_max;
                            }
                        }
                        
                        var triggerObj=albumBook.find(".cover[data-level='"+cur_level+"']").eq(0);
                        triggerObj.closest(".cell").trigger("click");
                    });
                    
                    albumBook.find(".popcorn[data-type]").each(function(){
                        var obj=$(this),index=_moduleTimeHandler.getNewIndex(),index2=_moduleTimeHandler.getNewIndex();
                        var anim_range=[500,4500];
                        function makeAnim(){
                            _moduleTimeHandler.setOne(index2,function(){
                                first=0;
                                obj.throwDown(_moduleTimeHandler,index,{v_arr:[2,1]});
                                 makeAnim();
                            },mt_rand(anim_range[0],anim_range[1]));
                            anim_range=[1500,8200];
                        }
                        makeAnim();
                    });
                    
                }
            });
//            albumBook.bookUse("show");
        }
        prepareAlbumBook();
        prepareCanvas();
        initGirlList();
        prepareGirlCss();
        if(!girlIsOwn){
            
        
            prepareQuickHappy();
            prepareGiftBook();
            prepareDateBook();
            prepareFilm();
            initNeed();
            
            if(collectBook.length){
                prepareCollect();
            }
            giftInput.myFormText({val_arr:[1,5,10,50,100,500,1000,5000,10000],on_update:function(val){
                showGift(cur_gift_id,val);
            }});
            dateInput.myFormText({val_arr:[1,5,10,50,100,500,1000,5000,10000],on_update:function(val){
                showDate(cur_date_id,val);
            }});
            _moduleEvents.on("skillNewLevel",function(){
                prepareNeed();
            });
            _moduleEvents.on("hideCover",function(name){
                if(name=="cashprogress"){
//                    albumBook.one("open",function(){
//                        albumBook.find(".partDown .cellWrap .cover").last().closest(".cell").trigger("click"); 
//                    }).bookUse("show",0,"not_trigger").one("close",function(){
//                        prepareNeed();
//                    });
                   
                    //noneInfo
                }
            });
        }
        else{
            var filmIndexTime=_moduleTimeHandler.getNewIndex();
            var lastBeltPos="bottom";
            function girlsAnimShow(girl_id,main,pos_id){
                pos_id=intval(pos_id);
                pos_id=Math.max(1,pos_id);
                
                if(typeof from_php.girl_own.extrapos[pos_id]=="undefined"){
                    pos_id=1;
                }
                else{
                    if(intval(from_php.girl_own.extrapos[pos_id]["have"])==0 && from_php.girl_own.level<intval(from_php.girl_own.extrapos[pos_id]["level"])){
                        pos_id=1;
                    }
                }
                
                
                function animByPNG(){
                    
                    var conf=$.takeGirlConf(girl_id,"video_png");
                    conf=conf[pos_id];
                    var path=""+_IMG_SERV+"/gfx/girls_anim_extra/"+$.takeGirlImage(girl_id)+"/"+pos_id+"/anim.png"+$.takeGirlVersion(girl_id);
                    var obj=main.find("#outputG");
                    obj.hide().css("background-image","url("+path+")").attr("data-pos_id",pos_id);
                    
                    main.one("myPreloaderInit",function(){

                    }).one("myPreloaderEnd",function(){
                        obj.fadeIn(500);
                        var newBeltPos="bottom";
                        //data-belt_pos="top"
                        
                        if(typeof conf.belt!="undefined"){
                            newBeltPos=conf.belt;
                        }
                        if(lastBeltPos!=newBeltPos){
                            lastBeltPos=newBeltPos;
                            main.find("#posChooseJS").hide().attr("data-belt_pos",lastBeltPos).fadeIn(500);
                        }
                        _moduleTimeHandler.clear(filmIndexTime);
                        main.find("#girl:visible,#girl_extend,#girl_suit").hide();
                        main.find("#suitChageJS").remove();
                        main.find("#posChooseJS").trigger("updateView");
                        obj.css({width:conf.width+"px",height:conf.height+"px"});
                        var step=-1,step_max=conf.clips;
                        var anim_name=_mySound.playSound("girl_play");
                        main.find("#girlTrigger").css({
                            width:conf.width+"px",
                            height:conf.height+"px",
                            left:intval(obj.css("left"))+"px",
                            top:intval(obj.css("top"))+"px"
                        });
                        _moduleTimeHandler.set(filmIndexTime,function(){
                            step++;
                            if(step>=step_max){
                                step=0;
                            }
                            obj.css("background-position","-"+(conf.width*step)+"px 0px");
                        },40,function(){
                            //clear
                            _mySound.stopSound(anim_name);
                        });

                    }).myPreloader({urlArr:[path],addToLoader:0},_moduleTimeHandler);

                }

                animByPNG();
                _moduleEvents.trigger("dialogSex");
                return pos_id;
            }
        }
        prepareThermo(from_php.girl);
        if(!girlIsOwn){
            needObj.find(".cell[data-gift_id]").click(function(){
                var th=$(this);
                _mySound.playSound("button_click");
                var gift_id=intval(th.attr("data-gift_id")),
                gift_count=intval(th.attr("data-count"));
                if(gift_count>0){
                    showGift(gift_id,gift_count);
                }
                else{
                    giftsBook.bookUse("show");
                }
                return false;

            });
            needObj.find(".cell[data-date_id]").click(function(){
                _mySound.playSound("button_click");
                var th=$(this);
                var gift_id=intval(th.attr("data-date_id")),
                gift_count=intval(th.attr("data-count"));
                if(gift_count>0){
                    showDate(gift_id,gift_count);
                }
                else{
                    datesBook.bookUse("show");
                }
                return false;

            });
            if(from_php.post_state){
                _moduleTimeHandler.addOne(function(){
                    $.goToLocation("girls/"+from_php.girl_id+"/",{post_state:from_php.post_state});
                },1000);
            }
            main.find("#recButtJSRowUn").click(function(){
                _mySound.playSound("button_click");
                needObj.find(".cell").trigger("triggerCam");
            });
        }
        else{
            var posextraObj=main.find("#posChooseJS");
            function showPosExtraUnable(pos_id){
                var book=main.find(".book.extrapos");
                var conf=from_php.girl_own.extrapos[pos_id];
                book.find("#extraposLvlJS").html(conf.level);
                book.find("#extraposButJS").attr("data-need",conf.premium+"p").updateButton().find(".in").html(conf.premium);
                book.find("#extraposInputJS").attr("value",pos_id);
                book.bookUse("show");
            }
            function initPosExtra(){
                //from_php.girl_stat.img
                var c_pos_id,bum,html="";
                for(c_pos_id in from_php.girl_own.extrapos){
                    bum=from_php.girl_own.extrapos[c_pos_id];
                    if(intval(bum.have)==1 || from_php.girl_own.level>=intval(bum.level)){
                        //have
                        html+=
                        '<div class="cell" data-pos_id="'+c_pos_id+'">'+
                            '<div class="img" style="background-image:url('+_IMG_SERV+'/gfx/girls_anim_extra/'+from_php.girl_stat.img+'/'+c_pos_id+'/full/IMG_0001.png'+$.takeGirlVersion(from_php.girl_id)+')"></div>'+
                        '</div>';    
                    }
                    else{
                        html+=
                        '<div class="cell unable" data-pos_id="'+c_pos_id+'">'+
                            '<div class="img">'+
                                '<div class="val">'+bum.level+'</div>'+
                            '</div>'+
                        '</div>';    
                    }
                }
                posextraObj.html(html);
                posextraObj.find(".cell").click(function(){
                    var th=$(this),c_pos_id=intval(th.attr("data-pos_id"));
                    if(th.is(".unable")){
                        showPosExtraUnable(c_pos_id);
                        return false;
                    }
                    else{
                        quickHappyObj.trigger("click",c_pos_id);
                    }
                    
                });
                posextraObj.hide().removeClass("hide").fadeIn(1500);
            }
            function checkTriggerPos(){
                var c_pos_id,bum;
                for(c_pos_id in from_php.girl_own.extrapos){
                    bum=from_php.girl_own.extrapos[c_pos_id];
                    if(typeof bum.trigger !="undefined" && intval(bum.trigger)){
                        quickHappyObj.trigger("click",intval(c_pos_id));
                        break;
                    }
                }
            }
            var cur_pos_id=0;
            quickHappyObj.on("click",function(e,val){
                if(cur_pos_id==0){
                    initPosExtra();
                }
                if(val=="newlevel"){
                    girlsAnimShow(from_php.girl.girl_id,main,1);
                    cur_pos_id=1;
                }
                else if(typeof val=="number"){
                    if(val!=cur_pos_id){
                        cur_pos_id=girlsAnimShow(from_php.girl.girl_id,main,val);
                    }
                }
                else{
                    var next_pos_id=0;
                    if(cur_pos_id==0){
                        next_pos_id=1;
                    }
                    else{
                        next_pos_id=1;
                        var c_pos_id,bum;
                        for(c_pos_id in from_php.girl_own.extrapos){
                            bum=from_php.girl_own.extrapos[c_pos_id];
                            if((intval(bum.have)==1 || from_php.girl_own.level>=intval(bum.level)) && intval(c_pos_id)>cur_pos_id){
                                next_pos_id=intval(c_pos_id);
                                break;
                            }
                        }
                    }
                    if(next_pos_id>0 && next_pos_id!=cur_pos_id){
                        cur_pos_id=next_pos_id;
                        girlsAnimShow(from_php.girl.girl_id,main,cur_pos_id);
                    }
                    
                }
                posextraObj.find(".cell[data-pos_id]").removeClass("active").filter("[data-pos_id='"+cur_pos_id+"']").addClass("active");
               
            }); 
            checkTriggerPos();
        }
        
    }
    var timerBook=main.find(".book.isDateBook");
    if(intval(from_php.date.time_end)>getCurrentTime()){
        var date_timer=from_php.date;
        var cur_time=getCurrentTime(),last_cost=0;
        var dateFormObj=timerBook.find("#dateForm");

        girls_date($.takeGirlImage(from_php.girl_id),from_php.date.date_place);
        
        
        
        timerBook.find("#dateBelt .fill").beltTimer(
            cur_time-intval(date_timer.time_start),intval(date_timer.time_end)-intval(date_timer.time_start),date_timer.time_end,
            {on_step:
                function(){
                    cur_time=getCurrentTime();
                    var howlong=intval(date_timer.time_end)-cur_time;
                    var tmp=countTimeCost(howlong);
                    var date=copyObj(from_php.date_stat[from_php.date.date_id]);
                    tmp=Math.ceil(date.premium*howlong/date.howlong);
                    
                    if(tmp!=last_cost){
                        last_cost=tmp;
                        dateFormObj.find("#premiumDJS").html(last_cost).closest(".myButton").attr("data-need",last_cost+"p");
                        dateFormObj.find("input[name='speedUpPremium']").val(last_cost);
                    }
                },
            on_end:
                function(){
                    $.goToLocation("girls/"+from_php.girl_id+"/",{post_state:"date_ended"});
                }
            }
        );
        _timerManager.addTimer(".place.girls .book.isDateBook #dateBelt #dateTimeShowJS",date_timer.time_end,1);
        
        
    }
    else if(timerBook.length>0){
        girls_date($.takeGirlImage(from_php.girl_id),from_php.date.date_place);
    }
    function animGirl(){
        if(_moduleTimeHandler.isIndexSet(indexArr.girl)){
            return false;
        }
        var girlObj= main.find("#girl");
        var state=100,add=[-1,1],dir=0;
        
        
        
        _moduleTimeHandler.set(indexArr.girl,function(){
            state+=add[dir];
            if(state<=97){
                dir=1;
            }
            if(state>=100){
                state=100;
                 _moduleTimeHandler.clear(indexArr.girl);
            }
            
            girlObj.css("background-size",(state)+"%");
            
            
        },40,function(){
            girlObj.css("background-size","100%");
        });
    }
    function prepareMemoryAlbum(){
        var book=main.find(".book.memoryalbum");
        if(!book.length){
            return false;
        }
        var bookList=book.find("#memoryAJS");
        if(!bookList.length){
            return false;
        }
        bookList.myPageSelector({width:609,height:315});
    }
    prepareMemoryAlbum();
    
//    main.on('touchend', function(e) {
//        e.preventDefault();
//        $(this).click();
//    });
    
    
//    main.find(".book.bookFilmStory .filmObjCover[data-girl_id='2'][data-level='4']").filmCoverShow();
    main.find(".book .filmObjCover[data-girl_id]").filmCoverShow();
    if(intval(main.find("#girlNewLevel").attr("data-trigger_anim"))){
        afterCanvasLoad.addFun(function(){
            init_girls_clip_anim(main,from_php,animCanvas,"after");
        });
        
    }
    main.find(".book.bookStats").one("open",function(){
       initBookStats();
    });//.show().trigger("open");
    function onWindowShowSet(){
        function handleQuestId6(){
            if(getQuestVars()=="in_girls"){
                girlObj.makeStatus();
                var arr=girlObj.user;
                if(arr.howlong_have<arr.howlong_end){
                    prepareQuest(0,"happy");
                }
            }
        }
        
        if(getQuestId()==3 || getQuestId()==6){
            main.find(".book#bookGameJS").off("open.Girl close.Girl").on("open.Girl",function(){
                prepareQuest(0,"book");
            }).on("close.Girl",function(){
                if(getQuestId()==6){
                    handleQuestId6();
                }
                else{
                    prepareQuest(0,0);
                }
            });
        }
        if(getQuestId()==6){
            handleQuestId6();
        }
        if(getQuestId()==8){
            main.find(".book.heartBook").on("close",function(){
                arrQuest8("start");
            }).on("open",function(){
                arrQuest8("book");
            });
            arrQuest8("start");
        }
    }
    onWindowShowSet();
    _moduleEvents.on("modulePopupClose",function(){
//        onWindowShowSet();
//        prepareNeed();
    });
    
    function q3Tut(){
        var quest3obj=main.find("#heartJSquest3>.in"),tick=main.find("#heartJSquest3>.tick");
        if(!quest3obj.length){
            return false;
        }
        var step=0,step_tick=0;
        _moduleTimeHandler.add(function(){
            step=step%130;
            if(step>100){
                step++;
            }
            else{
                step+=2;
            }
            var step_show=step;
            if(step>100){
                
                step_show=100;
                step_tick=Math.min(3,step-100);
                
                if(step<105){
                    tick.show();
                }
                if(step==110){
                    tick.fadeOut(800);
                }
            }
            else if(step<3){
                step_tick=0;
            }
            
            tick.attr("data-step",step_tick);
            quest3obj.html(step_show+"%");
        },40);
    }
    q3Tut();
    _moduleEvents.on("speed_bonus_global",function(){
        $.goToLocation("girls");
    });
    if(girlIsOwn){
        init_girls_suit(main,from_php);
    }
    
    if(main.find(">#girlNewLevel").length==0){
        showGirlDialog(from_php.langs.dialog,1500,"dialog");
        _moduleEvents.one("dialogSex",function(){
            showGirlDialog(from_php.langs.dialog_sex,30,"sex");
        });
    }
    else{
        _moduleEvents.one("girlAnimEnd",function(){
            showGirlDialog(from_php.langs.dialog,30,"dialog");
        });
        _moduleEvents.one("dialogSexNew",function(){
            showGirlDialog(from_php.langs.dialog_sex,30,"sex");
        });
        
    }
    
}
$(function(){
    _filmCoverStorage={};
    $.fn.filmCoverShow=function(){
        function prepareCoverData(girl_id,level){
            if(typeof _filmCoverStorage[girl_id]=="undefined"){
                _filmCoverStorage[girl_id]={};
            }
            if(typeof _filmCoverStorage[girl_id][level]=="undefined"){
                
                var obj=$("<div><div class='place girls' data-girl_id='"+girl_id+"' data-girl_level='"+level+"'data-girl_name='"+$.takeGirlImage(girl_id)+"'><div id='girl'></div></div></div>");
                $("#tmpUseIt").html("").append(obj);
                var girlTmp=obj.find("#girl");
                var left=intval(girlTmp.css("left")),top=intval(girlTmp.css("top")),width=girlTmp.width(),height=girlTmp.height();
                _filmCoverStorage[girl_id][level]={width:width,height:height,left:left,top:top};
                $("#tmpUseIt").html("");
            }
            return _filmCoverStorage[girl_id][level];
        }
        return this.each(function(){
            var th=$(this),data=copyObj(th.data());
            var bigSize={width:1280,height:780},girlSize=prepareCoverData(data.girl_id,data.level);
            var place_id=Math.ceil(data.girl_id/5),backgroudSize,prop;
            var girlImgName=$.takeGirlImage(data.girl_id),place_img=place_id,
            place_girl_own=["cherry","lola","sanshi","ice","geeky"];
            if(in_array(girlImgName,place_girl_own)){
                place_img=girlImgName;
            }
            var pos=[girlSize.left/bigSize.width*100,girlSize.top/bigSize.height*100];
            if(girlSize.width>girlSize.height){
                pos[1]+=(girlSize.width-girlSize.height)/2/bigSize.height*100;
            }
            else{
                pos[0]+=(girlSize.height-girlSize.width)/2/bigSize.width*100;
            }
            var obj={
                "background-image":"url("+_IMG_SERV+"/gfx/place/girls/places/"+place_img+".jpg)",
                "background-size":"auto "+bigSize.height*100/Math.min(Math.max(girlSize.width,girlSize.height),bigSize.height)+"%",
                "background-position":girlSize.left/bigSize.height*100+"% "+girlSize.top/bigSize.height*100+"%",
            };
            var css_girl="";
            if(girlSize.width==1280 && girlSize.height==780){
                css_girl="background-size:auto 100%;";
                obj["background-position"]="center";
            }
            th.css(
                obj
            ).find(".girlObjCover").remove();
    
            th.prepend("<div class='girlObjCover' "+
            "style='background-image: url("+_IMG_SERV+"/gfx/girls/"+$.takeGirlImage(data.girl_id)+"/position/ready/"+data.level+".png"+$.takeGirlVersion(data.girl_id)+");"+css_girl+"'></div>");
            //    background-size: auto 151%;
            //background-position: 46% 14%;
           //517,438 w,h
           //352,73  l,t
           
           //1280,780
        });  
    }; 
});





